import React, { useContext } from "react";

/// React router dom
import { Switch, Route, Redirect } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";

/// Dashboard
import Home from "./components/Dashboard/Home";
import DashBoardWidget from "./components/Dashboard/DashBoardWidget";
// import InvoicesList from "./components/Dashboard/InvoicesList";

import ManualBookkeepingEntry from "./components/Bookkeeping/ManualBookkeepingEntry";

/// Dashboard - Verifications
import Verifications from "./components/Accounting/Verification/Verifications";

import BookkeepingChatInterface from "./components/Bookkeeping/BookkeepingChatInterface";

import FiscalYearDetails from "./components/Accounting/FiscalYearDetails";

import EmployeeList from "./components/AppsMenu/Personell/EmployeeList";
import NewEmployee from "./components/AppsMenu/Personell/NewEmployee";
import EditEmployee from "./components/AppsMenu/Personell/EditEmployee";
import ViewEmployee from "./components/AppsMenu/Personell/ViewEmployee";

import NewContract from "./components/AppsMenu/Personell/NewContract";
import EditContract from "./components/AppsMenu/Personell/EditContract";

import PayrollPeriods from "./components/AppsMenu/Salary/PayrollPeriods";
import MonthlyPayrollPeriod from "./components/AppsMenu/Salary/MonthlyPayrollPeriod";
import Payslip from "./components/AppsMenu/Salary/Payslip";

import CreateSupplierInvoice from "./components/AppsMenu/supplier-invoices/CreateSupplierInvoice";
import InvoiceList from "./components/AppsMenu/Invoices/InvoiceList";
import ViewInvoice from "./components/AppsMenu/Invoices/ViewInvoice";
import CustomersTable from "./components/AppsMenu/Factoring/Customers/CustomersTable";
import ViewCustomerDetailed from "./components/AppsMenu/Factoring/Customers/ViewCustomerDetailed";
import ViewSupplierDetailed from "./components/AppsMenu/Factoring/Suppliers/ViewSupplierDetailed";
import SuppliersTable from "./components/AppsMenu/Factoring/Suppliers/SuppliersTable";
import ArticlesTable from "./components/AppsMenu/Factoring/Articles/ArticlesTable";
import InvoiceForm from "./components/AppsMenu/Invoices/InvoiceForm";
import CreditNoteForm from "./components/AppsMenu/Invoices/CreditNoteForm";

// New invoice form
import InvoiceDetailBootstrap from "./components/AppsMenu/Invoices/newinvoiceform/InvoiceDetailBootstrap";

import CreditNoteGenerator from "./components/AppsMenu/Invoices/newinvoiceform/CreditNoteGenerator";


import SupplierInvoiceList from "./components/AppsMenu/supplier-invoices/SupplierInvoiceList";
import ViewSupplierInvoice from "./components/AppsMenu/supplier-invoices/ViewSupplierInvoice";

import QuoteList from "./components/AppsMenu/Quotes/QuotesList";
import QuoteForm from "./components/AppsMenu/Quotes/QuoteForm";
import ViewQuote from "./components/AppsMenu/Quotes/QuoteViewer";

import QuoteGeneratorBootstrap from "./components/AppsMenu/Quotes/newquotes/QuoteGeneratorBootstrap";

import CreateVerification from "./components/Accounting/Verification/NewVerification";

import CreateBookkeepingEntry from "./components/Bookkeeping/BookkeepingEntryWizard";

import CreateVerificationFromCopy from "./components/Accounting/Verification/CreateCopyVerification";
import EditVerification from "./components/Accounting/Verification/EditVerification";

import ViewSchedule from "./components/AppsMenu/Scheduling/ViewSchedule";

import CompanySettings from "./components/Settings/CompanySettings";

import TemplateEditor from "./components/Settings/TemplateEditor";

import VatReportingPeriods from "./components/Reporting/Vat/VatReportingPeriods";
import VatPeriodDetails from "./components/Reporting/Vat/VatPeriodDetails";
import VatPeriodStepper from "./components/Reporting/Vat/VatPeriodStepper";

import MainLedgerReport from "./components/Reporting/Ledger/MainLedgerReport";
import BalanceReport from "./components/Reporting/Balance/BalanceReport";
import ResultReport from "./components/Reporting/Result/ResultReport";


/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import { useFeatures } from "../context/FeatureContext";

import UserSettings from "./components/Settings/UserSettings";

import AcceptInvite from "./pages/AcceptInvite";

import GenericImporter from "./components/SharedComponents/GenericImporter";

import BankStatementView from "./components/Banking/BankStatementView";
import BankStatementImporter from "./components/Banking/BankStatementImporter";
import BankAccountMappings from "./components/Banking/BankAccountMappings";
import SkatteverketStatementView from "./components/Skatteverket/SkatteverketStatementView";
import SkatteverketImporter from "./components/Skatteverket/SkatteverketImporter";


const useFeatureCheck = () => {
  const { features, hasLoaded } = useFeatures();

  return featureName => {
    // If no feature name is provided, allow access
    if (!featureName) return true;

    // If features haven't been loaded from backend yet, deny access
    if (!hasLoaded) {
      return false;
    }

    const hasAccess = Boolean(features[featureName]);

    return hasAccess;
  };
};

const ProtectedRoute = ({ component: Component, requiredFeature, ...rest }) => {
  const { features, isLoading, hasLoaded } = useFeatures();
  const hasFeature = useFeatureCheck();
  const companyId = window.location.pathname.split("/")[1];

  return (
    <Route
      {...rest}
      render={props => {
        // If no feature is required, render immediately
        if (!requiredFeature) {
          return <Component {...props} />;
        }

        // Wait for features to load from backend before checking access
        if (!hasLoaded || isLoading) {
          return (
            <div className="vh-100 d-flex justify-content-center align-items-center">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          );
        }

        return hasFeature(requiredFeature) ? (
          <Component {...props} />
        ) : (
          <Redirect to={{
            pathname: `/${companyId}/feature-disabled`,
            state: { feature: requiredFeature }
          }} />
        );
      }}
    />
  );
};


const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const { features, isLoading } = useFeatures();

  let path = window.location.pathname;
  path = path.split("/");
  const companyId = path[1];

  path = path[path.length - 1];
  let pagePath = path.split("-").includes("page");

  const routes = [
    /// Dashboard
    {
      url: "",
      component: Home
    },
    {
      url: ":companyId/dashboard",
      component: Home
    },
    {
      url: ":companyId/dashboard2",
      component: DashBoardWidget,
      requiredFeature: "dashboard_widget"
    },

    {
      url: ":companyId/bankstatements",
      component: BankStatementView,
      requiredFeature: "banking_integration"
    },
    {
      url: ":companyId/bankstatements/import",
      component: BankStatementImporter,
      requiredFeature: "banking_integration"
    },
    {
      url: ":companyId/skattekonto",
      component: SkatteverketStatementView,
      requiredFeature: "banking_integration"
    },
    {
      url: ":companyId/skatteverket/import",
      component: SkatteverketImporter,
      requiredFeature: "banking_integration"
    },
    {
      url: ":companyId/bank-accounts",
      component: BankAccountMappings,
      requiredFeature: "banking_integration"
    },

    {
      url: ":companyId/:importType/import",
      component: GenericImporter
    },

    {
      url: ":companyId/customers",
      component: CustomersTable,
      requiredFeature: "invoicing"
    },

    {
      url: ":companyId/customers/:customerId",
      component: ViewCustomerDetailed,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/articles",
      component: ArticlesTable,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/suppliers",
      component: SuppliersTable,
      requiredFeature: "expense_management"
    },
    {
      url: ":companyId/suppliers/:supplierId",
      component: ViewSupplierDetailed,
      requiredFeature: "expense_management"
    },

    {
      url: ":companyId/invoices",
      component: InvoiceList,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/supplier-invoices",
      component: SupplierInvoiceList,
      requiredFeature: "expense_management"
    },
    {
      url: ":companyId/supplier-invoices/:invoiceId",
      component: ViewSupplierInvoice,
      requiredFeature: "expense_management"
    },
    {
      url: ":companyId/edit-supplier-invoice/:invoiceId",
      component: CreateSupplierInvoice,
      requiredFeature: "expense_management"
    },
    {
      url: ":companyId/create-invoices",
      component: InvoiceForm,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/create-credit-note/:invoiceId",
      component: CreditNoteForm,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/edit-Credit-note/:invoiceId",
      component: CreditNoteForm,
      requiredFeature: "invoicing"
    },

    // Add these routes in the routes array (around line 275, after the existing credit note routes)
    {
      url: ":companyId/create-credit-note-new/:invoiceId",
      component: CreditNoteGenerator,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/edit-credit-note-new/:invoiceId",
      component: CreditNoteGenerator,
      requiredFeature: "invoicing"
    },

    {
      url: ":companyId/create-supplier-invoices",
      component: CreateSupplierInvoice,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/edit-invoice/:invoiceId",
      component: InvoiceForm,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/view-invoice/:invoiceId",
      component: ViewInvoice,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/view-invoice-new/:invoiceId",
      component: InvoiceDetailBootstrap,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/quotes",
      component: QuoteList,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/create-quote",
      component: QuoteForm,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/edit-quote/:quoteId",
      component: QuoteForm,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/view-quote/:quoteId",
      component: ViewQuote,
      requiredFeature: "invoicing_quotes"
    },

    {
      url: ":companyId/create-quote-new",
      component: QuoteGeneratorBootstrap,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/edit-quote-new/:quoteId",
      component: QuoteForm,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/view-quote-new/:quoteId",
      component: ViewQuote,
      requiredFeature: "invoicing_quotes"
    },


    { url: ":companyId/verifications", component: Verifications },


    //Employees
    { url: ":companyId/employees", component: EmployeeList },
    //{ url: "employee/:id", component: ViewEmployee },
    { url: ":companyId/create-employee", component: NewEmployee },
    { url: ":companyId/edit-employee/:id", component: EditEmployee },
    { url: ":companyId/schedule", component: ViewSchedule },

    //Contracts

    //{ url: "employee/:id/newcontract", component: NewContract },


    /// Settings
    { url: ":companyId/settings", component: CompanySettings },
    { url: ":companyId/user/:userId/settings", component: UserSettings },
    { url: ":companyId/templates/:templateId", component: TemplateEditor },

    /// Reporting
    { url: ":companyId/vat-periods", component: VatReportingPeriods },
    { url: ":companyId/vat-period/:vatPeriodId", component: VatPeriodDetails },

    { url: ":companyId/reports/mainledger", component: MainLedgerReport },
    { url: ":companyId/reports/balance", component: BalanceReport },
    { url: ":companyId/reports/result", component: ResultReport },

    // AI
    {
      url: ":companyId/ai-assistant",
      component: BookkeepingChatInterface,
      requiredFeature: "ai_assistant"
    },


    /// pages
    { url: "page-register", component: Registration },
    { url: "page-login", component: Login },
    { url: "page-forgot-password", component: ForgotPassword },
    { url: "page-error-400", component: Error400 },
    { url: "page-error-403", component: Error403 },
    { url: "page-error-404", component: Error404 },
    { url: "page-error-500", component: Error500 },
    { url: "page-error-503", component: Error503 },
  ];

  // Show loading indicator while features are loading
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading features...</span>
        </div>
      </div>
    );
  }


  return (
    <>
      <div id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${menuToggle ? "menu-toggle" : ""
          }`}
      >
        {!pagePath && <Nav companyId={companyId} />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div className={`${!pagePath ? "container-md" : ""}`} style={{ minHeight: window.screen.height - 60 }}>
            <Switch>
              {routes.map((data, i) => (
                <ProtectedRoute
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                  requiredFeature={data.requiredFeature}
                />
              ))}

              {/*<Route path="/:companyId/edit-invoice/:id" component={EditInvoice} />*/}

              <Route path="/:companyId/employee/:id/contract/:contractId/edit" component={EditContract} />
              <Route path="/:companyId/employee/:id/newcontract" component={NewContract} />
              <Route path="/:companyId/employee/:id" component={ViewEmployee} />
              {/*<Route path="/:companyId/supplier-invoice/:id" component={EditInvoice} />*/}
              <Route path="/:companyId/payroll/periods" component={PayrollPeriods} />
              <Route path="/:companyId/payroll/:year/:month" component={MonthlyPayrollPeriod} />
              <Route path="/:companyId/payslip/:id" component={Payslip} />
              <Route path="/:companyId/accounting/fiscal-years/:fiscalYearId" component={FiscalYearDetails} />

              {/*<Route path="/payroll/:year" component={MonthlyPayrollPeriod} />*/}
              {/*<Route path='/:companyId/newverification' component={CreateVerification} />*/}
              <Route path='/:companyId/edit-verification/:verificationId' component={EditVerification} />
              <Route path='/:companyId/copy-verification' component={CreateVerificationFromCopy} />

              <Route path='/:companyId/create-bookkeeping-entry' component={CreateBookkeepingEntry} />
              <Route path="/:companyId/manual-bookkeeping-entry" component={ManualBookkeepingEntry} />

              <Route path="/:companyId/vat-period-stepper/:vatPeriodId" exact>
                <VatPeriodStepper />
              </Route>

            </Switch>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <ScrollToTop />
    </>
  );
};

export default Markup;
